export type EvaluationSubmissionRecordingAvailability =
	| 'showModule'
	| 'waitUntilShared'
	| 'onlyManagerCanRecord';

export function getEvaluationSubmissionRecordingAvailability(submission: {
	employee: { hasShared: boolean };
	manager: { hasShared: boolean; viewerCanUpdate: boolean };
}): EvaluationSubmissionRecordingAvailability {
	if (!submission.employee.hasShared || !submission.manager.hasShared) {
		return submission.manager.viewerCanUpdate ? 'waitUntilShared' : 'onlyManagerCanRecord';
	}

	return 'showModule';
}
